module.exports = "<div ng-include=\"'header'\"></div>\n\n<div id=\"content\" class=\"container-fluid\">\n  <div class=\"row full-height\">\n    <sidebar view-type=\"vm.viewType\" class=\"col-md-2 col-sm-3 col-xs-12\"></sidebar>\n    <list id=\"list\" ng-if=\"vm.viewType === 'list'\" class=\"col-md-10 col-sm-9 col-xs-12 state-content\"></list>\n    <dashboard ng-if=\"vm.viewType === 'dashboard'\" class=\"col-md-10 col-sm-9 col-xs-12 state-content\"></dashboard>\n  </div>\n</div>\n\n<footer/>"


//////////////////
// WEBPACK FOOTER
// ./client/app/main/main.html
// module id = 21
// module chunks = 0